import React from 'react'

function CustomerType(user) {
  let inner_customer_type = "Khách lẻ TADU"
  if(user.role == "AGENCY" && user.agency && user.agency.has_custom_brand == true) {
    inner_customer_type = "Đại Lý Thương Hiệu Riêng"
  }
  if(user.role == "AGENCY" && user.agency && user.agency.has_custom_brand == false) {
    inner_customer_type = "Đại Lý TADU"
  }
  if(user.role == "CUSTOMER" && user.agency && !user.agency.has_custom_brand ) {
    inner_customer_type = <React.Fragment> Khách Hàng của Đại Lý <br/> <small style={{color: "#42A5F5"}}> {user.agency.agency_admin.email} </small> </React.Fragment>
	}
	if(user.role == "CUSTOMER" && user.agency && user.agency.has_custom_brand) {
    inner_customer_type = <React.Fragment> Khách Hàng Đại Lý Thương Hiệu <br/> <small style={{color: "#42A5F5"}}> {user.agency.agency_admin.email} </small> </React.Fragment>
	}
  return inner_customer_type;
}
export default CustomerType;